import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import CustomItemStatus from "../../../../../../common/components/custom_item_status";


type Props = {
    onActionEdit: (idNovosNegocios: number | null, openState: boolean) => void,
    onActionDelete: (idNovosNegocios: number | null, openState: boolean) => void,
    onActionEmail: (idNovosNegocios: number | null, openState: boolean) => void;
    onActionExportar: (idNovosNegocios: number) => void,

}

export const GenerateNovosNegociosColumns = ({
    onActionEdit,
    onActionDelete,
    onActionExportar,
    onActionEmail,

}: Props): GridColDef[] => {
    const computeStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Em análise";
            case 1:
                return "Participar";
            case 2:
                return "Descartar";
            case 3:
                return "Concluído com sucesso";
            default:
                return "?";
        }
    };

    const computeStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "#c6c6c6";
            case 1:
                return "#45b6af";
            case 2:
                return "#f3565d";
            case 3:
                return "#27ae60";
            default:
                return "#0303FF";
        }
    };

    const computeStatusDescription = (status: number) => {
        switch (status) {
            case 0:
                return "Em análise";
            case 1:
                return "Participar da licitação";
            case 2:
                return "Descartar";
            case 3:
                return "Projeto concluído com sucesso";
            default:
                return "?";
        }
    };

    // Situacao functions
    const computeSituacaoTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Ganha";
            case 1:
                return "Perdida";
            case 2:
                return "Inabilitada";
            case 3:
                return "Outros";
            default:
                return "?";
        }
    };

    const computeSituacaoColor = (status: number) => {
        switch (status) {
            case 0:
                return "#45b6af";
            case 1:
                return "#f3565d";
            case 2:
                return "#c6c6c6";
            case 3:
                return "#f8cb00";
            default:
                return "#0303FF";
        }
    };

    const computeSituacaoDescription = (status: number) => {
        switch (status) {
            case 0:
                return "Ganha";
            case 1:
                return "Perdida";
            case 2:
                return "Inabilitada";
            case 3:
                return "Outros";

            default:
                return "?";
        }
    };

    return [
        {
            field: "nrNegocio",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            sortable: false,
        },
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 150,
            maxWidth: 200,
            sortable: false,
            valueGetter: (_, row) => ({
                status: row['status'] as number,
                situacao: row['situacao'] as number,
            }),
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2">
                    <CustomItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeStatusTitle(value.situacao)}
                        bgColor={computeStatusColor(value.situacao)}
                        description={computeStatusDescription(value.situacao)} />
                    {
                        (value.situacao === 1 && value.status !== null) && // Exibir o status de situação apenas para negócios a participar
                        <CustomItemStatus
                            size="autowidth"
                            textSize="small"
                            title={computeSituacaoTitle(value.status)}
                            bgColor={computeSituacaoColor(value.status)}
                            description={computeSituacaoDescription(value.status)} />

                    }


                </div>
            )
        },
        {
            field: "dataInicio",
            filterable: false,
            headerName: "Data de Início",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "nomeCliente",
            filterable: false,
            headerName: " Cliente",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "cidade",
            filterable: false,
            headerName: "Cidade",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "titulo",
            filterable: false,
            headerName: "Título",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro de Custo",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            sortable: false,
            valueGetter: (_, row) => row['idNovosNegocios'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => onActionExportar(value)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },
        {
            field: 'email',
            sortable: false,
            filterable: false,
            headerName: 'Enviar Email',
            width: 65,
            valueGetter: (_, row) => row['idNovosNegocios'] as number,
            renderCell: ({ value }) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton onClick={() => { onActionEmail(value, true) }}>
                            <DynamicIcon nameIcon="EmailOutlined" size={25} className="text-[#009C4E]" />
                        </IconButton>
                    </div>
                );
            }
        },

        {
            field: 'idNovosNegocios',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }



    ];

}